import { render } from "./PriorityActions.vue?vue&type=template&id=303806da&scoped=true"
import script from "./PriorityActions.vue?vue&type=script&lang=js"
export * from "./PriorityActions.vue?vue&type=script&lang=js"

import "./PriorityActions.vue?vue&type=style&index=0&id=303806da&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303806da"]])

export default __exports__